<template>
  <div v-editable="blok" ref="blokView" :class="styles" :style="style">
    <div class="controls text-center" ref="controls">
      <button class="btn btn-primary play-button" @click="expand">{{ blok.cta }}</button>
    </div>
    <iframe
      ref="video"
      class="video-frame"
      :src="blok.source.vimeo_raw"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allow="autoplay; fullscreen"
    ></iframe>
    <div class="postreel-cta">
      <component
        :key="index"
        v-for="(child,index) in blok.postreel"
        :blok="child"
        :is="child.component"
      ></component>
      <div class="text-center" ref="postreel-controls">
        <button class="btn btn-primary" @click="resume">{{ videoComplete ? 'Replay' : 'Resume' }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import Player from "@vimeo/player";
import { setTimeout } from "timers";

export default {
  name: "vimeo-blok",
  props: ["blok"],
  data: () => {
    return {
      videoComplete: false
    };
  },
  methods: {
    track: function(event) {
      try {
        gtag("event", event, {
          event_category: "video_interaction",
          event_label: blok.source.vimeo_raw
        });
      } catch (e) {
        console.warn(e);
      }
    },
    expand: function() {
      this.$refs.blokView.classList.remove("collapsed");
      this.$refs.controls.classList.add("invisible");
      setTimeout(() => {
        const videoContainer = this.$refs.blokView;
        const videoControls = this.$refs.controls;
        const videoPlayer = this.$refs.video;
        const postReel = this.blok.postreel;
        const player = new Player(videoPlayer);
        //
        try {
          gtag("event", "expand", {
            event_category: "video_interaction",
            event_label: blok._uid
          });
        } catch (e) {
          console.warn(e);
        }
        //
        videoPlayer.classList.remove("invisible");
        videoContainer.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        //
        player.play();
        //
        this.track("play");
        //
        player.on("pause", function(data) {
          if (postReel.length > 0) {
            videoContainer.classList.add("postreel");
            videoContainer.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          } else {
            videoContainer.classList.add("collapsed");
            videoControls.classList.remove("invisible");
          }
          this.track("pause");
        });
        //
        player.on("ended", function(data) {
          if (postReel.length > 0) {
            videoContainer.classList.add("postreel");
            this.videoComplete = true;
            videoContainer.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          } else {
            videoContainer.classList.add("collapsed");
            videoControls.classList.remove("invisible");
          }
          this.track("complete");
        });
        //
        player.on("resume", function(data) {
          if (postReel.length > 0) {
            videoContainer.classList.remove("postreel");
            videoContainer.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
          this.track("resume");
        });
      }, 1000);
    },
    resume: function() {
      this.$refs.blokView.classList.remove("postreel");
      this.expand();
    }
  },
  computed: {
    styles: function() {
      const b = this.$props.blok;
      return [
        "vimeo-blok",
        b.width,
        b.ratio,
        b.align,
        b.border,
        b.styles,
        b.view_type
      ];
    },
    style: function() {
      return {
        backgroundImage: `url(${this.blok.background})`
      };
    }
  }
};
</script>